/**
 * Обертка над MentionSelect из @udecode/slate-plugins для правильного позиционирования
 * списка, если он частично скрывается за экраном
 *
 * Через ref работать не получится, т.к. ref не форвардится в MentionSelect,
 * поэтому достаем список через querySelector
 */

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { MentionSelect } from '@udecode/slate-plugins';

export const CustomMentionSelect = props => {
  const [top, setTop] = useState<number>();
  const baseTopRef = useRef<number | null>(null);

  useEffect(() => {
    const el = document.querySelector('.slate-MentionSelect');
    if (!el) return;

    const rect = el.getBoundingClientRect();

    if (baseTopRef.current == null) {
      baseTopRef.current = rect.top;
    }

    const newTop = Math.max(
      window.scrollY,
      baseTopRef.current - rect.height - 30
    );
    setTop(newTop);
  }, [props.options.length]);

  return (
    <StyledMentionSelect {...props} $top={top} className="mentionSelect" />
  );
};

const StyledMentionSelect = styled(MentionSelect)<{ $top?: number }>`
  ${({ $top }) =>
    !!$top &&
    `
        top: ${$top}px !important;
      `}
`;
